exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch.switch--disable .ant-switch-checked {\n  background-color: #f5222d;\n}\n", ""]);

// exports
